import {
	HttpRequest,
	HttpHandler,
	HttpEvent,
	HttpInterceptor,
	HttpErrorResponse,
} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Router} from '@angular/router';

import {Observable, of, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';

import {TokenStore} from '../services/stores/token.store';
import {UserStore} from '../services/stores/user.store';
import {ConfigService} from '@core/config/config.service';

/**
 * Provides Interceptor to clone request with JWT header
 */
@Injectable()
export class TokenInterceptor implements HttpInterceptor {
	constructor(
		private tokenStore: TokenStore,
		private router: Router,
		private userStore: UserStore,
		private configService: ConfigService
	) {}

	intercept(
		req: HttpRequest<any>,
		next: HttpHandler
	): Observable<HttpEvent<any>> {
		const domain = this.configService.getDomain();
		if (this.tokenStore.checkToken() && domain && req.url.includes(domain)) {
			const token = this.tokenStore.getTokenRaw();
			req = this.addHeader(req, token);
		}
		return next.handle(req).pipe(catchError(x => this.handleAuthError(x)));
	}

	private handleAuthError(err: HttpErrorResponse): Observable<any> {
		if (
			err.status === 401 &&
			err.url !== (this.configService.getApiUrl() || '') + '/login' &&
			err.url !== (this.configService.getApiUrl() || '') + '/auth/verify'
		) {
			this.tokenStore.clearToken();
			this.userStore.clearUser();

			this.router.navigate(['/login']).then(() => window.location.reload());
			return of(err?.message); // or EMPTY may be appropriate here
		}
		return throwError(err);
	}

	private addHeader = (
		req: HttpRequest<any>,
		token: string | undefined
	): HttpRequest<any> =>
		req.clone(token ? {setHeaders: {Authorization: 'Bearer ' + token}} : {});
}
